const overrideFieldIds = (fields, newFieldIdsByTarget) => {
  return fields.map((field) => ({
    ...field,
    id: "target" in field ? newFieldIdsByTarget[field.target] : field.id
  }));
};
export {
  overrideFieldIds
};
//# sourceMappingURL=field-id-overrides.js.map
